import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = useState(5);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 990-EZ FAQs: Answers to Nonprofit Filing Questions"
          description="Get answers to common Form 990-EZ filing questions. Learn about eligibility, filing deadlines, required schedules, extensions, and e-filing with TaxZerone."
          keywords=""
          canonical="faqs/form-990-ez/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 990-EZ</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 990-EZ
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(9)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(10)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 990
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What is a 990 EZ tax form?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box component="div" itemProp="text">
                          <Typography sx={{ mt: 1, mb: 2 }}>
                            IRS Form 990-EZ is a simplified version of Form 990,
                            which serves as an annual information return filed
                            by{' '}
                            <Hidden smDown>
                              {' '}
                              <br />
                            </Hidden>{' '}
                            tax-exempt organizations under section 501(c) of the
                            Internal Revenue Code. Exempt organizations with
                            gross receipts less than $200,000 and total assets
                            less than $500,000 must file 990 EZ form with the
                            IRS.
                          </Typography>
                          <Typography sx={{ mb: 0 }}>
                            The 990-EZ short form is specifically designed for
                            small to medium-sized tax-exempt organizations,
                            including specific nonprofits and charities.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Can I look up a tax-exempt organization's Form 990-EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <span style={{ fontWeight: 600 }}> Yes</span> .
                          Tax-exempt organizations are generally required to
                          make their{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990-ez/"
                            sx={{ color: '#0202ff' }}
                          >
                            IRS Form 990 EZ
                          </Link>{' '}
                          filing available for public inspection. While the IRS
                          Tax Exempt Organization Search (TEOS) allows you to
                          access publicly available filings,{' '}
                          <Link href="/" sx={{ color: '#0202ff' }}>
                            TaxZerone
                          </Link>{' '}
                          also provides a secure{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990FINDER_SITE_URL}?ref=faq`}
                            sx={{ color: '#0202ff', fontWeight: 600 }}
                          >
                            {' '}
                            EIN Finder tool
                          </Link>{' '}
                          to help you quickly locate an organization's EIN and
                          simplify your search.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How to file Form 990 EZ electronically?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Typography sx={{ mb: 0 }}>
                            To{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990-ez/"
                              sx={{ color: '#0202ff' }}
                            >
                              file Form 990 EZ electronically
                            </Link>
                            , choose an IRS-authorized e-file provider, enter or
                            review your organization's information, complete the
                            required sections of the return, and submit it to
                            the IRS. If you're new to TaxZerone, our IRS2File
                            feature automatically retrieves eligible
                            organization information from IRS records, helping
                            you complete your filing faster with less manual
                            entry.
                          </Typography>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How do I fill out Schedule O for Form 990-EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Box
                            component="ul"
                            sx={{ mb: 0, '& li': { mb: 1.2 } }}
                          >
                            <li>
                              When completing{' '}
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Schedule O Form 990 EZ
                              </span>
                              , provide any additional details needed to support
                              your responses on Form 990-EZ.
                            </li>
                            <li>
                              <Link
                                href="/resources/tax-exempt/form-990-schedule-o/"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                990 EZ Schedule O
                              </Link>{' '}
                              should clearly reference the relevant section of
                              the return and include only the information
                              necessary to explain your filing.
                            </li>
                          </Box>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Who Can File Form 990 EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          Tax-exempt organizations can file{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990-ez/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Form 990-EZ
                          </Link>{' '}
                          if they meet the IRS eligibility requirements.
                          Generally, an organization may file Form 990-EZ if it
                          has:
                          <Box
                            component="ul"
                            sx={{ mb: 0, '& li': { mb: 1.2 } }}
                          >
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Gross receipts of less than $200,000
                              </span>{' '}
                              for the tax year, and
                            </li>
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Total assets of less than $500,000
                              </span>{' '}
                              at the end of the tax year.
                            </li>
                          </Box>
                          <Typography variant="body1">
                            Organizations that exceed either of these thresholds
                            are generally required to{' '}
                            <Link
                              href="/tax-exempt/e-file-irs-form-990/"
                              sx={{ color: '#0202ff' }}
                            >
                              file Form 990
                            </Link>{' '}
                            instead. Certain organizations, such as private
                            foundations and some other tax-exempt entities, must
                            file different IRS forms regardless of their size.
                          </Typography>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When is Schedule B required for Form 990-EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Box
                            component="ul"
                            sx={{ mb: 0, '& li': { mb: 1.2 } }}
                          >
                            <li>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Schedule B
                              </span>{' '}
                              is required when a tax-exempt organization
                              receives contributions from donors that meet the
                              IRS reporting thresholds during the tax year.
                            </li>
                            <li>
                              Organizations that are required to{' '}
                              <Link
                                href="/resources/tax-exempt/form-990-schedule-b/"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                file Schedule B
                              </Link>
                              must report information about qualifying
                              contributors as part of their annual return.
                            </li>
                            <li>
                              While the schedule is submitted to the IRS, the
                              public disclosure of donor information depends on
                              the organization's{' '}
                              <Link
                                href="/tax-exempt/"
                                sx={{ color: '#0202ff' }}
                              >
                                tax-exempt
                              </Link>{' '}
                              classification and applicable IRS rules.
                            </li>
                          </Box>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How to correct errors in previously filed Form 990-EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                            You can easily{' '}
                            <Link
                              href="/tax-exempt/e-file-form-990-amendments/"
                              sx={{ color: '#0202ff' }}
                            >
                              amend your Form 990-EZ
                            </Link>{' '}
                            after it has been accepted by the IRS.
                          </Typography>
                          <Box
                            component="ul"
                            sx={{ mb: 0, '& li': { mb: 1.3 } }}
                          >
                            <li style={{ fontWeight: 600 }}>
                              If you used TaxZerone to file the original return:
                            </li>
                            <ol>
                              <li>
                                Go to Exempt Organization Forms dashboard.{' '}
                              </li>
                              <li>Choose Form 990-EZ. </li>
                              <li>
                                Clicking on “Amend Return” will automatically
                                transfer all field values from the original
                                return to the amended one.{' '}
                              </li>
                              <li>
                                You must provide a reason for the amendment,
                                correct any errors, and submit the amended
                                return to the IRS.{' '}
                              </li>
                            </ol>
                            <li>
                              In case you filed your original Form 990-EZ with
                              another service provider, easily make amendments
                              using{' '}
                              <Link href="/" sx={{ color: '#0202ff' }}>
                                {' '}
                                TaxZerone
                              </Link>
                              .{' '}
                            </li>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What schedules may be required with Form 990-EZ?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          variant="body1"
                          component="div"
                          itemProp="text"
                        >
                          <Box
                            component="ul"
                            sx={{ mb: 0, '& li': { mb: 1.3 } }}
                          >
                            <li>
                              Depending on your organization's activities, you
                              may need to attach schedules such as
                            </li>
                            <ul>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-a/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule A
                                </Link>{' '}
                                - Public Charity Status and Public Support
                              </li>
                              <li>
                                {' '}
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-b/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  Schedule B
                                </Link>{' '}
                                - Schedule of Contributors{' '}
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-c/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule C
                                </Link>{' '}
                                - Political Campaign and Lobbying Activities
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-e/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  Schedule E
                                </Link>{' '}
                                - Schools
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-g/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule G
                                </Link>{' '}
                                - Information Regarding Fundraising or Gaming
                                Activities
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-l/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule L
                                </Link>{' '}
                                - Transactions With Interested Persons
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-n/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule N
                                </Link>{' '}
                                - Liquidation, Termination, Dissolution, or
                                Significant Disposition of Assets or
                              </li>
                              <li>
                                <Link
                                  href="/resources/tax-exempt/form-990-schedule-o/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule O
                                </Link>{' '}
                                - Supplemental Information with Form 990-EZ.
                              </li>
                            </ul>
                            <li>
                              The schedules required vary based on your
                              organization's reporting requirements and
                              activities during the tax year.
                            </li>
                          </Box>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
